export const transfromFontSize = (type: string, currentFontSize : any) => { 
  const defaultFontKitchen = 16;
  const defaultFontReceipt = 11; 

  const kitchenFontMap = {
    "0": 16,
    "0.1":18,
    "0.2":20
  }
  const receiptFontMap = {
    "0": 11,
    "0.3":13,
    "0.5":15
  } 

  //Check currentFontSize is empty
  let _currFontSize = currentFontSize
  if(!currentFontSize){
    if(type == "receipt"){
      _currFontSize = defaultFontReceipt
    }else{
      _currFontSize = defaultFontKitchen
    }
  }
  
   
  
  //if new version setting
  if(parseFloat(_currFontSize) > 1 ){
    return parseFloat(_currFontSize);
  }

  if(type == "receipt"){
    return receiptFontMap[_currFontSize] || defaultFontReceipt;
  }

  return kitchenFontMap[_currFontSize] || defaultFontKitchen;
}